enum ExternalBillingType {
  None = '',
  MagneticStripe = 'magnetic-stripe',
  Numeric = 'numeric',
  Auth = 'contact-person-credentials',
}

export default ExternalBillingType;
